import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import FeedbackAlert from "./Private/Dashboard/FeedbackAlert";

const pathVariants = {
  hidden: { rotate: -90, opacity: 0.3, pathLength: 0 },
  visible: {
    rotate: 0,
    opacity: 1,
    pathLength: 1,
    transition: { duration: 1, ease: "easeInOut" },
  },
};

const menuVariants = {
  opened: {
    y: "-100vh",
    transition: {
      duration: 0.5,
      ease: "easeInOut",
    },
  },
  closed: {
    y: 0,
    transition: {
      type: "tween",
    },
  },
};

const Header = ({ navigation }) => {
  const [isHamburgerOpen, setisHamburgerOpen] = useState(false);
  const [styles, setStyles] = useState("");

  useEffect(() => {
    if (isHamburgerOpen) {
      setStyles("");
    } else setStyles("hidden");
  }, [isHamburgerOpen]);

  return (
    <>
      <FeedbackAlert />
      <div ref={navigation} className="relative bg-white ">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="flex justify-between items-center border-b-2 border-gray-100 py-6 md:justify-start md:space-x-10">
            {/** Logo Image */}
            <div className="hidden md:flex justify-start lg:w-0 lg:flex-1">
              <Link to="/">
                <span className="sr-only">MPocket</span>
                <div className="flex items-center space-x-2 ">
                  <img
                    className="h-8 w-auto sm:h-10"
                    src="https://tailwindui.com/img/logos/workflow-mark-indigo-600.svg"
                    alt=""
                  />
                  <h1 className="text-3xl tracking-tight font-extrabold text-gray-700">
                    <span className="text-blue-700 font-black">M</span>Pocket
                  </h1>
                </div>
              </Link>
            </div>

            <div className="hidden md:flex items-center md:space-x-10 md:justify-center md:flex-auto">
              <Link
                to="/"
                className="text-base font-medium text-gray-500 hover:text-gray-900"
              >
                Home
              </Link>
              {/* Item active: "text-gray-900", Item inactive: "text-gray-500" */}
              <Link
                to="/"
                className="text-base font-medium text-gray-500 hover:text-gray-900"
              >
                Services
              </Link>

              <Link
                to="/"
                className="text-base font-medium text-gray-500 hover:text-gray-900"
              >
                Pricing
              </Link>
              <Link
                to="/"
                className="text-base font-medium text-gray-500 hover:text-gray-900"
              >
                About
              </Link>
            </div>

            <div className="hidden md:flex items-center justify-end md:flex-1">
              <Link
                to="/SignIn"
                className="whitespace-nowrap text-base font-medium text-gray-500 hover:text-gray-900"
              >
                Sign in
              </Link>
              <Link
                to="/SignUp"
                className="ml-8 whitespace-nowrap inline-flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-indigo-600 hover:bg-indigo-700"
              >
                Sign up
              </Link>
            </div>

            {/**Mobile */}
            <div className="md:hidden flex flex-col w-full space-y-5">
              <div className="md:hidden flex items-center justify-between w-full">
                <div className="md:hidden flex justify-start lg:w-0 lg:flex-1">
                  <Link to="/">
                    <span className="sr-only">MPocket</span>
                    <div className="flex items-center space-x-2 ">
                      <img
                        className="h-8 w-auto sm:h-10"
                        src="https://tailwindui.com/img/logos/workflow-mark-indigo-600.svg"
                        alt=""
                      />
                      <h1 className="text-3xl tracking-tight font-extrabold text-gray-700">
                        <span className="text-blue-700 font-black">M</span>
                        Pocket
                      </h1>
                    </div>
                  </Link>
                </div>
                {/** open Hamburger Menu */}
                {!isHamburgerOpen && (
                  <div className="-mr-2 -my-2 md:hidden">
                    <button
                      type="button"
                      className={` bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500`}
                      aria-expanded="false"
                      onClick={() => setisHamburgerOpen(true)}
                    >
                      <span className="sr-only">Open Menu</span>

                      <svg
                        className="h-6 w-6"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        aria-hidden="true"
                      >
                        <motion.path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M4 6h16M4 12h16M4 18h16"
                          variants={pathVariants}
                          initial="hidden"
                          animate="visible"
                        />
                      </svg>
                    </button>
                  </div>
                )}

                {/**close hamburger */}
                {isHamburgerOpen && (
                  <div className="md:hidden -mr-2">
                    <button
                      type="button"
                      className={` bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500`}
                      onClick={() => setisHamburgerOpen(false)}
                    >
                      <span className="sr-only">Close menu</span>

                      <svg
                        className="h-6 w-6"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        aria-hidden="true"
                      >
                        <motion.path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M6 18L18 6M6 6l12 12"
                          variants={pathVariants}
                          initial="hidden"
                          animate="visible"
                        />
                      </svg>
                    </button>
                  </div>
                )}
              </div>

              <motion.div
                className={`${styles} flex flex-col w-full transition-all	`}
                initial={false}
                variants={menuVariants}
                animate={!isHamburgerOpen ? "opened" : "closed"}
              >
                <div className="w-full md:hidden border-b-2 border-gray-100 space-y-5 flex items-center flex-col">
                  <Link
                    to="/"
                    className="text-base font-medium text-gray-500 hover:text-gray-900"
                  >
                    Home
                  </Link>
                  {/* Item active: "text-gray-900", Item inactive: "text-gray-500" */}
                  <Link
                    to="/Services"
                    className="text-base font-medium text-gray-500 hover:text-gray-900"
                  >
                    Services
                  </Link>

                  <Link
                    to="/Pricing"
                    className="text-base font-medium text-gray-500 hover:text-gray-900"
                  >
                    Pricing
                  </Link>
                  <Link
                    to="/About"
                    className="text-base font-medium text-gray-500 pb-5 hover:text-gray-900"
                  >
                    About
                  </Link>
                </div>

                <div className="md:hidden space-y-3 flex items-center flex-col pt-5">
                  <Link
                    to="/SignIn"
                    className="pb-2 whitespace-nowrap text-base font-medium text-gray-500 hover:text-gray-900"
                  >
                    Sign in
                  </Link>
                  <Link
                    to="/SignUp"
                    className="whitespace-nowrap inline-flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-indigo-600 hover:bg-indigo-700"
                  >
                    Sign up
                  </Link>
                </div>
              </motion.div>
            </div>
            {/**End Mobile */}
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
